// extracted by mini-css-extract-plugin
module.exports = {"flexStyle":"style_flexStyle__zlDYM"};